import { Component } from '@angular/core';
import { GUITAR_LESSONS } from './guitar-lessons.data';

@Component({
  selector: 'app-guitar-lessons',
  templateUrl: './lessons.component.html',
  styleUrls: ['./lessons.component.scss'],
  standalone: false,
})
export class GuitarLessonsComponent {
  lessons = GUITAR_LESSONS;
}
